/* -------------------------------------------------------------------------- */
/*                                   Common                                   */
/* -------------------------------------------------------------------------- */

export const NOT_APPLICABLE = 'N/A';

export const LINKEDIN_URL =
	'https://www.linkedin.com/company';

export const X_URL = 'https://www.x.com';

export const INUK_URL = 'https://inuk.co/';

export const STAGING = 'Staging';

export const LOCAL = 'Local';

export const DEMO = 'Demo';

export const DEVELOP = 'Develop';

export const CONTACT_US_INUK_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSeiRaY65zqjpojCLVgRnG3yi739cdxyMQ8qCSd7deownfwWrQ/viewform';

export const CONTACT_US_AREC_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSet4PvNiRgGzThIipLoGbAki6mVqRfemDTHYT2QH9F7EB6P9Q/viewform?pli=1';

export const BG_INUK =
	'https://res.cloudinary.com/inuk/image/upload/v1757086085/inukBg5_lueedx.jpg';
export const BG_INUK_TABLET =
	'https://res.cloudinary.com/inuk/image/upload/v1760368815/Frame_1000002568_lkyoqs.svg';
export const BG_INUK_MOBILE =
	'https://res.cloudinary.com/inuk/image/upload/v1760371150/c077fdc831dc50c932322fb50da5b0ed39adea31_sjyat7.jpg';

export const BG_AREC =
	'https://res.cloudinary.com/inuk/image/upload/v1757085493/Illustration-login-AREC-V3--test-hauteur2.jpg_ngnath.jpg';
export const BG_AREC_TABLET =
	'https://res.cloudinary.com/inuk/image/upload/v1760371958/f8ac3d6cd0ea6d0c6c75582c76a4d7bf7c08235e_tc75ms.jpg';
export const BG_AREC_MOBILE =
	'https://res.cloudinary.com/inuk/image/upload/v1760371990/585652744d7739cc208c79c56558b6860aa3e773_puiypp.jpg';
